import { FC, ReactNode } from 'react'
import { PlanTag, PlanTagType } from './Tag'

const Plan: FC & PlanTagType = (): ReactNode => <></>

Plan.Tag = PlanTag

export default Plan
